import React, { useEffect, useState } from 'react';
import { formatDateToMin } from '../../utils/DateUtils';
import { GeocodingService } from '../../pages/services/GeocodingService';
import { useTranslation } from 'react-i18next';

interface LastUpdateProps {
    onGeocodingResult: (result: boolean) => void;
    lastUpdateData: {
        orderList: Array<{
            lastPosition: {
                positionDetectionDateTimeUTC: string;
                latitude: number;
                longitude: number;
            };
            status: string | null;
        }>;
    } | null;
}

const LastUpdate: React.FC<LastUpdateProps> = ({ onGeocodingResult, lastUpdateData }) => {
    const dotClassName = `h-2.5 w-2.5 rounded-full mr-2 ${lastUpdateData ? "bg-red" : "bg-[#757575]"}`;
    const col = 'flex flex-row items-center max-w-fit';
    const [lastPos, setLastPos] = useState<string | undefined>();
    const [fetched, setFetched] = useState<boolean>(false);

    const lastPosition = lastUpdateData?.orderList?.[0]?.lastPosition;
    const formattedLastUpdate = lastPosition
        ? new Date(lastPosition.positionDetectionDateTimeUTC)
        : null;

    useEffect(() => {
        let isMounted = true;

        if (lastPosition?.latitude && lastPosition?.longitude) {
            GeocodingService.reverseGeocode(
                lastPosition.latitude,
                lastPosition.longitude,
                (result: any) => {
                    if (isMounted) {
                        setLastPos(result.items[0]?.address?.city);
                        setFetched(true);
                        onGeocodingResult(true);
                    }
                }
            );
        }

        return () => {
            isMounted = false;
        };
    }, [lastPosition, onGeocodingResult]);

    const {t} = useTranslation();
    return (
        <div className="row overflow-hidden items-center">
            {fetched && lastPos ? (
                <div className={col}>
                    <div className={dotClassName}></div>
                    <p>
                        Updated on {formattedLastUpdate ? formatDateToMin(formattedLastUpdate) : 'N/A'}{" "}
                        near <span style={{ color: "#3987E2", fontWeight: 600 }}>{lastPos}</span>
                    </p>
                </div>
            ) : (
                <div className={col}>
                    <div className={dotClassName}></div>
                    <p>{t('screens.trips.position.notAvailable')}</p>
                </div>
            )}
        </div>
    );
};

export default LastUpdate;
